// Canonical, stable keys for the company-facing system emails whose recipients
// can be overridden per company. Keep in sync with the backend's
// lib/recipient-rules.js EMAIL_TYPES.
export const EMAIL_TYPE_LABELS = {
    interview_scheduling_recruiter: 'Interview Scheduling — Recruiter',
    interview_scheduling_candidate: 'Interview Scheduling — Candidate',
    interview_cancelled_recruiter: 'Interview Cancelled — Recruiter',
    new_candidate_abt: 'New Candidate (Apply-by-Text)',
    inbound_message: 'Inbound Message Notification',
    broadcast_response: 'Broadcast Response',
    email_group_routing: 'Email-Group Routing',
    campaign_completion: 'Campaign Completion',
};

// Short human explanation of when each system email fires.
export const EMAIL_TYPE_DESCRIPTIONS = {
    interview_scheduling_recruiter: 'Sent to the recruiter when an interview is scheduled.',
    interview_scheduling_candidate: 'Sent to the candidate confirming their scheduled interview.',
    interview_cancelled_recruiter: 'Sent to the recruiter when a candidate cancels their interview by text.',
    new_candidate_abt: 'Sent to your team when a candidate applies via Apply-by-Text.',
    inbound_message: "Sent to the recruiter when a candidate replies to their personal texting number.",
    broadcast_response: "Sent to the campaign's notify list when a contact responds to a broadcast.",
    email_group_routing: 'Sent to an email group when a contact is routed to it in a flow.',
    campaign_completion: 'Sent to the campaign creator when a scheduled campaign finishes sending.',
};

export const emailTypeLabel = (key) => EMAIL_TYPE_LABELS[key] || key;

export const emailTypeDescription = (key) => EMAIL_TYPE_DESCRIPTIONS[key] || '';
